import type { LeaderboardEntry } from "./types";

export interface SpectrumPoint {
  entryIndex: number;
  lane: number;
  position: number;
}

export function scoreToPercentages(score: number): {
  p: number;
  j: number;
} {
  const bounded = Math.max(-100, Math.min(100, score));
  const j = Math.round((bounded + 100) / 2);
  return { p: 100 - j, j };
}

export function averageScore(entries: readonly LeaderboardEntry[]): number {
  if (entries.length === 0) return 0;
  return entries.reduce((sum, entry) => sum + entry.score, 0) / entries.length;
}

export function compareWithAverage(score: number, average: number): string {
  const difference = Math.round(Math.abs(score - average) / 2);
  if (difference === 0) return "和群平均位置一样";
  return `比群平均更 ${score < average ? "P" : "J"} ${difference}%`;
}

export function identityTitle(score: number): string {
  if (score <= -50) return "随机事件召集人";
  if (score <= -20) return "随性路线探索家";
  if (score < 20) return "弹性区旅行策划师";
  if (score < 50) return "行程收束推进员";
  return "全局流程掌舵人";
}

export function layoutSpectrum(
  entries: readonly LeaderboardEntry[],
  laneCount = 4,
  minimumGap = 12,
): SpectrumPoint[] {
  const lastPositionByLane = Array.from({ length: laneCount }, () => -Infinity);
  return entries.map((entry, entryIndex) => {
    const position = scoreToPercentages(entry.score).j;
    let lane = lastPositionByLane.findIndex(
      (lastPosition) => position - lastPosition >= minimumGap,
    );
    if (lane < 0) {
      lane = lastPositionByLane.indexOf(Math.min(...lastPositionByLane));
    }
    lastPositionByLane[lane] = position;
    return { entryIndex, lane, position };
  });
}
